<!-- 网站首页 -->
<template>
  <div class="swiper_group bg_000000">
    <!-- pc -->
    <div class="hidden-xs hidden-sm hidden-md">
      <div class="swiper_content" :style="{ backgroundImage: `url(${item.img_url})` }" :id="item.banner_id" v-for="(item, index) in shuju_shaixuan(swiper_list, 'PC', GET_LANG)">
        <!-- 预售状态 -->
        <div v-if="item.banner_type === '产品'" class="tabbar_content">
          <div class="tabbar_content_name color_ffffff font_72 font_misans font_bold">
            {{ get_productName(item.productorInfoModel) }}
            <span v-if="item.productorInfoModel.sellStatusID === 2" class="p_diamond bg_DC000C font_12">{{ $t('goods.sellstatus_yushou') }}</span>
            <span v-if="item.productorInfoModel.sellStatusID === 3" class="p_diamond bg_DC000C font_12">{{ $t('goods.sellstatus_xianhuo') }}</span>
          </div>
          <!-- tags -->
          <div v-if="get_tags(item.productorInfoModel)" class="goods_tags color_ffffff">
            <span v-for="(item2, index2) in get_tags(item.productorInfoModel)" :key="index2" class="goods_tags_item border_radius18 font_15 font_500">{{ item2 }}</span>
          </div>
          <!-- btn -->
          <div class="btn_group">
            <div @click="$router.push(`/productInfo`)" class="btn_item bg_ffffff color_DC000C font_24 font_800 p_text_center p_hand">{{ $t('goods.knowmore') }}</div>
            <!-- <a
              v-if="item.productorInfoModel.sellStatusID === 2 || item.productorInfoModel.sellStatusID === 3"
              :href="item.productorInfoModel.taobaoLink"
              target="_blank"
              class="btn_item a_biao bg_DC000C color_ffffff font_24 font_800 p_text_center p_hand"
            >
              {{ $t('goods.buybtn') }}
            </a> -->
            <!-- <div :href="item.productorInfoModel.taobaoLink" @click="$router.push('/verify')" class="btn_item bg_ffffff color_DC000C font_24 font_800 p_text_center p_hand">{{ $t('header.heyan') }}</div> -->
          </div>
        </div>
      </div>
      <!-- tabbar -->
      <!-- <public-switch @callback="callback" :tabbar_list="tabbar_list" :tabbar_idx="tabbar_idx" class="content_right"></public-switch> -->
      <div class="content_right p_flex p_column">
        <div
          v-for="(item, index) in shuju_shaixuan(swiper_list, 'PC', GET_LANG)"
          @click="click_tabbar(index, item.banner_id)"
          :class="tabbar_idx === index ? 'check_style' : ''"
          class="content_right_item p_flex p_row_reverse p_align_items p_hand"
        >
          <span :class="tabbar_idx === index ? 'check_dot' : ''" class="content_right_dot"></span>
          {{ item.link_content }}
        </div>
      </div>
    </div>
    <!-- h5 -->
    <div class="hidden-lg">
      <div class="swiper_content_h5" v-for="(item, index) in shuju_shaixuan(swiper_list, '移动端', GET_LANG)" :id="`swiper_h${index}`">
        <img class="swiper_img_h5" :src="item.img_url" alt="" />
        <!-- 预售状态 -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { swiper_list } from '@/network/index.js';
export default {
  name: '',
  data() {
    return {
      swiper_list: [],
      tabbar_idx: 0,
      dingwen: [],
      screenWidth: '', //屏幕宽度
      timer: null
    };
  },
  components: {},
  created() {
    this.get_swiper_list();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.resizeFunc);
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.resizeFunc);
  },
  computed: {
    ...mapGetters('setting', ['GET_LANG', 'GET_LANG2'])
  },
  methods: {
    // 页面宽度变化
    resizeFunc() {
      this.screenWidth = document.body.clientWidth;
    },
    //页面滚动事件
    handleScroll() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        //代码
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let vw = this.screenWidth / 100;
        let height1 = vw * 56.25;
        //console.log(parseInt(scrollTop / height1));
        this.tabbar_idx = parseInt(scrollTop / height1);
      }, 500);
    },
    //获取产品标签
    get_tags(obj) {
      let str = '';
      if (this.GET_LANG2 === 'cn') {
        str = obj.keyWordCn;
      } else if (this.GET_LANG2 === 'en') {
        str = obj.keyWordEn;
      } else if (this.GET_LANG2 === 'jp') {
        str = obj.keyWordJp;
      }
      if (str) {
        return str.split(',');
      } else {
        return [];
      }
    },
    //获取产品名称
    get_productName(obj) {
      switch (this.GET_LANG2) {
        case 'cn':
          return obj.productNameCn;
        case 'en':
          return obj.productNameEn;
        case 'jp':
          return obj.productNameJp;
      }
    },
    //锚点跳转
    goAnchor(banner_id) {
      let a = $('#' + banner_id).offset().top;
      $('html,body').animate({ scrollTop: a }, 'slow');

      // this.$nextTick(() => {
      //   document.getElementById(banner_id).scrollIntoView({
      //     behavior: 'smooth'
      //   });
      // });
    },
    //点击右侧的选项卡
    click_tabbar(idx, banner_id) {
      this.tabbar_idx = idx;
      this.goAnchor(banner_id);
    },
    //device设备，lang语言
    shuju_shaixuan(arr, device, lang) {
      let newarr = [...arr];
      let newlang = '';
      if (lang === 'zh') {
        newlang = 'CN';
      } else if (lang === 'en') {
        newlang = 'EN';
      } else if (lang === 'ja') {
        newlang = 'JPN';
      }
      if (arr.length === 0) {
        return [];
      }
      return newarr.filter(item => item.device === device && item.lang_type === newlang);
    },
    get_swiper_list() {
      //获取轮播图列表
      swiper_list({
        device: '',
        lang_type: '',
        banner_type: ''
      }).then(res => {
        if (res.code === '0') {
          this.swiper_list = [...res.data.bannerModelList];
        }
      });
    } //end
  }
};
</script>

<style scoped="scoped">
.swiper_group {
  min-height: 56.25vw;
}
.swiper_content {
  width: 100vw;
  max-height: 100vh;
  /* height: 56.25vw; */
  height: 100%;
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
}
.content_right {
  position: fixed;
  top: 50vh;
  right: 0px;
  transform: translateY(-50%);
  padding-right: 120px;
}
.swiper_content_h5 {
  width: 100%;
  background-size: 100%;
}
.swiper_img_h5 {
  width: 100%;
}
/* tabbar */
.content_right_item {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 800;
  padding: 25px 0;
  transition-property: color, fontSize;
  transition: 500ms;
}
.check_style {
  color: #fff;
  font-size: 24px;
}
.content_right_dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  margin-left: 10px;
  transition-property: background-color, width;
  transition: all 500ms;
}
.check_dot {
  background-color: #fff;
  width: 30px;
}
/*  */
.tabbar_content {
  position: absolute;
  top: 50vh;
  left: 0;
  transform: translateY(-50%);
  margin-left: 120px;
  width: 920px;
}
.tabbar_content_name {
  display: inline-block;
  position: relative;
  padding-bottom: 30px;
}
.p_diamond {
  display: inline-block;
  min-width: 58px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  margin-left: 10px;
  -webkit-transform: skew(-20deg);
  -moz-transform: skew(-20deg);
  -o-transform: skew(-20deg);
  -ms-transform: skew(-20deg);
  transform: skew(-20deg);
  text-align: center;
  font-size: 14px;
  color: #fff;
  font-weight: 800;
  position: relative;
  top: -40px;
}
.goods_tags {
  width: 100%;
  min-height: 20px;
}
.goods_tags_item {
  padding: 7px 15px;
  min-width: 20px;
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 0 30px 30px 0;
}
.a_biao:hover {
  color: #fff;
}
.a_biao {
  color: #fff;
}
.btn_item {
  display: inline-block;
  min-width: 200px;
  height: 60px;
  line-height: 60px;
  border-radius: 6px 6px 6px 6px;
  padding: 0 20px;
  margin: 30px 60px 0 0px;
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/public-swiper/public-swiper.vue